import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useDispatch } from "react-redux";

import { KeyValue } from "@/main/models/common";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { getTranslateByKey, isNullUndefined, isValueQueryParams } from "@/main/services/utils";
import { useDinamicFiltersMappingCodes } from "./dinamicFiltersMappingCodes";
import { getSuppliers, resetReducerSuppliers, useSupplierReducer } from "@/main/store/supplier";
import { HeadQuarterBranchFilterEnum } from "@/main/services/enum/HeadQuarterBranchFilterEnum";

export const INITIAL_FORM_STATE_SUPPLIER = {
	supplier: null as KeyValue | null,
};

export type IFormFiltersMappingTypeSupplier = typeof INITIAL_FORM_STATE_SUPPLIER;

interface IFiltersMappingTypeSupplierProps {}
function FiltersMappingTypeSupplier(_props: IFiltersMappingTypeSupplierProps) {
	const dispatch = useDispatch();
	const { watcherCountry, isRequiredField } = useDinamicFiltersMappingCodes();
	const { suppliers: suppliersReducer } = useSupplierReducer();

	const { control, resetField, setValue } = useFormContext<IFormFiltersMappingTypeSupplier>();

	useEffect(() => {
		if (!isValueQueryParams(watcherCountry)) {
			resetField("supplier");
		}
		if (isNullUndefined(watcherCountry)) return;

		dispatch(
			getSuppliers({
				guidCountry: String(watcherCountry?.key),
				type: HeadQuarterBranchFilterEnum.All,
				idStatusRegister: StatusRegisterEnum.Active,
			}),
		);

		return () => {
			dispatch(resetReducerSuppliers());
		};
	}, [JSON.stringify(watcherCountry?.key)]);

	const disabledSupplier = isNullUndefined(suppliersReducer.data) || suppliersReducer.data.length === 1;

	return (
		<KogAutoCompleteControlled
			id="id-mappingCode-select-supplier"
			nameCustom="supplier"
			label={getTranslateByKey("information.supplier")}
			isDefaultValueUnique
			control={control}
			setValueCustom={setValue}
			options={suppliersReducer.data}
			isLoading={suppliersReducer.isLoading}
			disabled={disabledSupplier}
			rulesCustom={{ required: isRequiredField("supplier") }}
			onChangeCustom={() => {}}
		/>
	);
}

export default FiltersMappingTypeSupplier;
